import * as moment from "moment";

/**
 * Checks if a given date is restricted (fully booked with count >= 31)
 * based on provided stage counts and user priority access.
 * 
 * @param dateValue - The date string or object to check.
 * @param stageCounts - Object mapping date strings (YYYY-MM-DD) to counts.
 * @param priorityDueDateAccess - Boolean indicating if the user can bypass restrictions.
 * @returns true if the date is restricted, false otherwise.
 */
export const isDateRestricted = (
    dateValue: any,
    stageCounts: any,
    priorityDueDateAccess: boolean
): boolean => {
    if (!dateValue) return false;
    if (priorityDueDateAccess) return false;

    const date = (moment as any)(dateValue);
    if (!date.isValid()) return false;

    const dateStr = date.format('YYYY-MM-DD');
    const count = (stageCounts as any)?.[dateStr] || 0;

    return count >= 35;
};
